module.exports = __webpack_public_path__ + "img/feature-4.00d87a39.webp";